import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import { playerDisplayName } from "./PlayerDisplayNameLink";
export var PlayerAvatar = function (_a) {
    var _b, _c, _d;
    var player = _a.player, _e = _a.size, size = _e === void 0 ? 56 : _e;
    var displayName = playerDisplayName(player);
    var tooltip = (_jsx(Tooltip, { title: displayName, arrow: true, children: _jsx(Avatar, { src: (_c = (_b = player === null || player === void 0 ? void 0 : player.user) === null || _b === void 0 ? void 0 : _b.picture) !== null && _c !== void 0 ? _c : undefined, alt: displayName, sx: { width: size, height: size }, children: (_d = displayName.match(/\b(\w)/g)) === null || _d === void 0 ? void 0 : _d.join("") }) }));
    if (!player) {
        return tooltip;
    }
    return (_jsx(Link, { style: { textDecoration: "none" }, to: "/players/".concat(player === null || player === void 0 ? void 0 : player.id, "/"), children: tooltip }, player === null || player === void 0 ? void 0 : player.id));
};
